import './polyfills.js';

import '@adyen/adyen-web/styles/adyen.css';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
import './index.css';

createRoot(document.getElementById('root')).render(<App />);
